import React, { useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { Button, Form, Spinner } from 'react-bootstrap'
import { AltaContext } from './AltaContext'

function Botones() {
  const { paso, next, back, loading } = useContext(AltaContext)
  const location = useLocation()
  const history = useHistory()

  return (
    <div className="container pb-3">
      {loading ? (
        <Spinner animation="border" variant="primary" />
      ) : (
        <Form.Group>
          {paso > 1 && paso <= 3 && (
            <Button onClick={() => back()} variant="secondary">
              Anterior
            </Button>
          )}
          {paso < 4 && (
            <Button onClick={() => next()} variant="primary">
              {paso !== 3 || location?.state?.visualizarDatos
                ? 'Siguiente'
                : 'Finalizar'}
            </Button>
          )}
          {location?.state?.visualizarDatos && (
            <Button
              variant="warning"
              onClick={() => history.push('/ddjj/gestion-contribuyente')}
            >
              Volver a gestión del contribuyente
            </Button>
          )}
        </Form.Group>
      )}
    </div>
  )
}

export default Botones
